import { graphql } from "../generated";

export const GetCurrentCompanyBilling = graphql(`
  query GetCurrentCompanyBilling {
    currentCompanyBilling
      @rest(type: "RestCompanyBilling", path: "company", endpoint: "v3") {
      billingPeriod
      address {
        line
        zip
        city
        state
        country
      }
    }
  }
`);
